import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes';
import Amplify, * as AmplifyModuls from 'aws-amplify';
import { AmplifyPlugin, AmplifyEventBus } from 'aws-amplify-vue';
import aws_exports from './aws-exports';
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'
import Vue2Filters from 'vue2-filters'
import { VueMasonryPlugin } from 'vue-masonry'
import InfiniteLoading from 'vue-infinite-loading'
import VueLazyLoad from 'vue-lazyload'
import BootStrapVue from 'bootstrap-vue'
import store from './vuex/store'
import * as VueGoogleMaps from "vue2-google-maps";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faAngleLeft, faShop, faShoppingCart, faSackDollar} from '@fortawesome/free-solid-svg-icons'
library.add(faAngleLeft, faShop, faShoppingCart, faSackDollar)

/**** CSS Import ****/
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'swiper/dist/css/swiper.css'
import './assets/scss/app.scss'
import VueSimpleAlert from "vue-simple-alert";


Amplify.configure(aws_exports);
Vue.use(AmplifyPlugin, AmplifyModuls);
Vue.use(VueRouter)
Vue.use(VueAwesomeSwiper)
Vue.use(Vue2Filters)
Vue.use(VueMasonryPlugin)
Vue.use(InfiniteLoading)
Vue.use(VueLazyLoad)
Vue.use(BootStrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAzZ5sy3bDltA2VOXerwtL2h7vX7GVcuMI",
    libraries: "places"
  }
});
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueSimpleAlert, { reverseButtons: true });

const { dispatch, getters } = store

dispatch('auth/findUser');

Vue.config.productionTip = false

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {

  var app_user_authenticated = getters['auth/appUserAuthed']
  var web_user_authenticated = getters['auth/webUserAuthed']

  if (to.matched.some(record => record.meta.requiresLogin) && ((!app_user_authenticated) && (!web_user_authenticated))) {
    next("/")
  } else {
    next()
  }

})


AmplifyEventBus.$on('authState', async (state) => {

  const pushPathes = {
    signedOut: () => {
      dispatch('logout')
      dispatch('auth/setSigninLog',{type: 'signed_out', 'signinusername':''});
      router.push({ name: 'login'})
    },
    signUp: () => {
      router.push({ path: '/account/register1' })
    },
    confirmSignUp: () => {
      router.push({ path: '/account/register_verify' })
    },
    confirmScreen: () => {
      router.push({ path: '/account/register3'}) // confirm_screen
    },
    signIn: () => {
      router.push({ path: '/login' })
    },
    signedIn: () => {
      dispatch('auth/findUser');
      dispatch('auth/setSigninLog',{type: 'signed_in', 'signinusername':''});
      router.push({ path: '/appstart' })
    },
    forgotPassword: () => {
      router.push({ path: '/forgot_password' })
    },

    signInRegistration: () => {
      dispatch('auth/findUser'); // sets access token
      dispatch('auth/setSigninLog',{type: 'signed_up', 'signinusername':''});
      router.push({ path: '/account/register4' })
    }

  }
  if (typeof pushPathes[state] === 'function') {
    pushPathes[state]()
  }
})


window.EventHub = new Vue()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
